module.exports = __webpack_public_path__ + "img/rincon-viamonte.dcde9555.jpg";